import Vue from "vue";
import VueRouter from "vue-router";
import Routes from "../views/index.js";

let routes = [];
Routes.map(route => {
  routes.push(route);
});

Vue.use(VueRouter);

const router = new VueRouter({
  routes
});

import { firebase } from "@firebase/app";
import "@firebase/auth";

firebase.getCurrentUser = () => {
  return new Promise((resolve, reject) => {
      const unsubscribe = firebase.auth().onAuthStateChanged(user => {
          unsubscribe();
          resolve(user);
      }, reject);
  })
};
router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth && !await firebase.getCurrentUser()){
    next('login');
  }else{
    next();
  }
});
export default router;